"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderAssetsIndicators = void 0;
var React = require("react");
var DataQualityType_1 = require("../dataQualityWarnings/DataQualityType");
var DataQualityIndicatorStyles_1 = require("../style/DataQualityIndicatorStyles");
var DataQualityIndicatorButtons_1 = require("./DataQualityIndicatorButtons");
var DataQualityIndicatorFragments_1 = require("./DataQualityIndicatorFragments");
var DataQualityIndicatorSharedHelpers_1 = require("./DataQualityIndicatorSharedHelpers");
function BigSpacer() {
    return (React.createElement("hr", { style: {
            borderColor: '#E6E6E6'
        } }));
}
function RenderIndicators(props) {
    return (React.createElement(React.Fragment, null, props.indicators.map(function (i, index) {
        return React.createElement(React.Fragment, { key: index },
            i.kind === 'certification' ?
                React.createElement("span", { style: { display: 'flex', } },
                    React.createElement(DataQualityIndicatorStyles_1.CertificationIconWrapperStyle, null,
                        React.createElement(DataQualityIndicatorButtons_1.DataQualityCertificationNonInteractiveIcon, null)),
                    React.createElement(DataQualityIndicatorSharedHelpers_1.DataQualityDetailAuthorElement, __assign({}, i)))
                :
                    React.createElement(React.Fragment, null,
                        React.createElement(DataQualityIndicatorButtons_1.DataQualityWarningNonInteractiveButton, { testId: DataQualityIndicatorSharedHelpers_1.DataQualityDetailChipId, title: DataQualityType_1.localizeDataQualityTypeName(i.type), warningKind: i.kind }),
                        React.createElement(DataQualityIndicatorSharedHelpers_1.DataQualityDetailAuthorElement, __assign({}, i))),
            React.createElement(DataQualityIndicatorSharedHelpers_1.DataQualityDetailDateElement, __assign({}, i)),
            React.createElement(DataQualityIndicatorSharedHelpers_1.DataQualityDetailMessageElement, __assign({}, i, { assetName: props.assetName })));
    })));
}
function RenderAnchoredAssetsIndicators(props) {
    if (props.indicators.length < 1) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DataQualityIndicatorStyles_1.IndicatorGroupHeadingDiv, null, DataQualityIndicatorFragments_1.onThisAssetMessage(props.assetType)),
        React.createElement(DataQualityIndicatorStyles_1.IndicatorAssetGroupDiv, null,
            React.createElement(DataQualityIndicatorSharedHelpers_1.DataQualityDetailAsset, { assetName: props.assetName, assetType: props.assetType, assetUrl: props.linksDisabled ? null : props.assetUrl }),
            React.createElement(DataQualityIndicatorStyles_1.IndicatorIndicatorsGroupDiv, null,
                React.createElement(RenderIndicators, { assetName: props.assetName, indicators: props.indicators })))));
}
function RenderAssetsIndicators(props) {
    if (props.indicators.length < 1 && props.upstream.length < 1) {
        return null;
    }
    return (React.createElement(React.Fragment, null,
        props.indicators.length > 0 && React.createElement(RenderAnchoredAssetsIndicators, __assign({}, props)),
        props.indicators.length > 0 && props.upstream.length > 0 && React.createElement(BigSpacer, null),
        props.upstream.length > 0 &&
            React.createElement(React.Fragment, null,
                React.createElement(DataQualityIndicatorStyles_1.IndicatorGroupHeadingDiv, null, DataQualityIndicatorFragments_1.upstreamOfThisAssetMessage(props.assetType)),
                React.createElement(DataQualityIndicatorStyles_1.IndicatorAssetGroupDiv, null, props.upstream.map(function (value) {
                    return React.createElement(React.Fragment, null,
                        React.createElement(DataQualityIndicatorSharedHelpers_1.DataQualityDetailAsset, { assetName: value.assetName, assetType: value.assetType, assetUrl: props.linksDisabled ? null : value.assetUrl }),
                        React.createElement(DataQualityIndicatorStyles_1.IndicatorIndicatorsGroupDiv, null,
                            React.createElement(RenderIndicators, { assetName: value.assetName, indicators: value.indicators })));
                })))));
}
exports.RenderAssetsIndicators = RenderAssetsIndicators;
//# sourceMappingURL=DataQualityIndicatorDetail.js.map